module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/d9e0fd6da7031be3ed69ef361ad28792.jpg";